import type { CameraControls } from '@react-three/drei';

import { isPlayerCameraUpdateBlocked } from './isPlayerCameraUpdateBlocked';
import type { PlayerStore } from '../store/playerStore';
import type { PlayerCameraControlsHandle } from '../types';

const gizmoGateAttached = new WeakSet<CameraControls>();

export function attachPlayerCameraGizmoGate(
  instance: CameraControls,
  store: PlayerStore,
): void {
  if (gizmoGateAttached.has(instance)) {
    return;
  }

  gizmoGateAttached.add(instance);

  const handle = instance as PlayerCameraControlsHandle;
  const originalSetLookAt = handle.setLookAt.bind(handle);
  const originalUpdate = handle.update.bind(handle);

  handle.setLookAt = (
    positionX: number,
    positionY: number,
    positionZ: number,
    targetX: number,
    targetY: number,
    targetZ: number,
    enableTransition?: boolean,
  ) => {
    if (isPlayerCameraUpdateBlocked(store)) {
      return;
    }

    originalSetLookAt(
      positionX,
      positionY,
      positionZ,
      targetX,
      targetY,
      targetZ,
      enableTransition,
    );
  };

  handle.update = (delta: number) => {
    if (isPlayerCameraUpdateBlocked(store)) {
      return;
    }

    originalUpdate(delta);
  };
}
